import { createSlice } from '@reduxjs/toolkit';

interface ModalState {
  isStakeModalOpen: boolean;
  isBetSlipModalOpen: boolean;
  isChangePasswordModalOpen: boolean;
  isProhibitedTerritoriesModalOpen: boolean;
  isUnderageModalOpen: boolean;
  isRulesModalOpen: boolean;
}

const initialState: ModalState = {
  isStakeModalOpen: false,
  isBetSlipModalOpen: false,
  isChangePasswordModalOpen: false,
  isProhibitedTerritoriesModalOpen: false,
  isUnderageModalOpen: false,
  isRulesModalOpen: false,
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openStakeModal: (state) => {
      state.isStakeModalOpen = true;
    },
    closeStakeModal: (state) => {
      state.isStakeModalOpen = false;
    },
    toggleStakeModal: (state) => {
      state.isStakeModalOpen = !state.isStakeModalOpen;
    },

    openBetSlipModal: (state) => {
      state.isBetSlipModalOpen = true;
    },
    closeBetSlipModal: (state) => {
      state.isBetSlipModalOpen = false;
    },
    toggleBetSlipModal: (state) => {
      state.isBetSlipModalOpen = !state.isBetSlipModalOpen;
    },

    openChangePasswordModal: (state) => {
      state.isChangePasswordModalOpen = true;
    },
    closeChangePasswordModal: (state) => {
      state.isChangePasswordModalOpen = false;
    },
    toggleChangePasswordModal: (state) => {
      state.isChangePasswordModalOpen = !state.isChangePasswordModalOpen;
    },

    openProhibitedTerritoriesModal: (state) => {
      state.isProhibitedTerritoriesModalOpen = true;
    },
    closeProhibitedTerritoriesModal: (state) => {
      state.isProhibitedTerritoriesModalOpen = false;
    },
    toggleProhibitedTerritoriesModal: (state) => {
      state.isProhibitedTerritoriesModalOpen = !state.isProhibitedTerritoriesModalOpen;
    },

    openUnderageModal: (state) => {
      state.isUnderageModalOpen = true;
    },
    closeUnderageModal: (state) => {
      state.isUnderageModalOpen = false;
    },
    toggleUnderageModal: (state) => {
      state.isUnderageModalOpen = !state.isUnderageModalOpen;
    },

    openRulesModal: (state) => {
      state.isRulesModalOpen = true;
    },
    closeRulesModal: (state) => {
      state.isRulesModalOpen = false;
    },
    toggleRulesModal: (state) => {
      state.isRulesModalOpen = !state.isRulesModalOpen;
    },
  },
});

export const {
  openStakeModal,
  closeStakeModal,
  toggleStakeModal,
  openBetSlipModal,
  closeBetSlipModal,
  toggleBetSlipModal,
  openChangePasswordModal,
  closeChangePasswordModal,
  toggleChangePasswordModal,
  openProhibitedTerritoriesModal,
  closeProhibitedTerritoriesModal,
  toggleProhibitedTerritoriesModal,
  openUnderageModal,
  closeUnderageModal,
  toggleUnderageModal,
  openRulesModal,
  closeRulesModal,
  toggleRulesModal,
} = modalSlice.actions;

export default modalSlice.reducer;
